import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAuditLogs = lazy(() => import("@/pages/admin/AdminAuditLogs"));

export const Route = createFileRoute("/admin/audit-logs")({
  component: AdminAuditLogs,
});
